import React, { memo } from 'react';
import MuiButton from '@material-ui/core/Button';
import { useTranslate } from 'ra-core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { useFilterFormContext } from '../../../context/form/filterForm.context';

const ButtonFilter = memo(() => {
  const { setFilterDisplayed, filterDisplayed } = useFilterFormContext();

  const translate = useTranslate();

  return (
    <MuiButton
      color="primary"
      variant="text"
      size="small"
      startIcon={filterDisplayed ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
      onClick={() => setFilterDisplayed(!filterDisplayed)}
    >
      {filterDisplayed ? translate('ra.action.hideFilter') : translate('ra.action.showFilter')}
    </MuiButton>
  );
});

export default ButtonFilter;
